import React, { useRef } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import axios from "axios";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useState } from "react";
import jsPDF from "jspdf";
import html2canvas from 'html2canvas';
import { partner_Admin, partner_Api } from "../../Configuration/Partner_URL";
import { Modal } from "react-bootstrap";
import { decryptData, encryptData } from "../../CommonMethhods/CommonMethods";

function PartnerInvoice() {
  let invoiceId = localStorage.getItem("invoiceId");
  const PartnerMobile = localStorage.getItem("PartnerMobile");
  const partnerMobileNo = localStorage.getItem("partnerMobileNo");
  const partnerFlag = localStorage.getItem("partnerFlag");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");

  const storeToken = localStorage.getItem("ssoToken");
  const [invoice, setInvoice] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [partnerId, setPartnerId] = useState("");
  const [showModal, setShowModal] = useState(true);
  const [inputVal, setInputVal] = useState("");
  const [passError, setPassError] = useState("Enter password as combination of your PartnerCode+PAN number.");
  const [invoiceVal, setInvoiceVal] = useState("");
  const [nameVal, setNameVal] = useState("");
  
  if(storeToken == null){
    window.location.replace("/")
  }

  if(storeToken == null){
    window.location.replace("/");
  }

  const pdfRef = useRef(null);
  const convertToPdf = () => {
    const input = pdfRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png', 1.0);
      const pdf = new jsPDF('l', 'mm', 'a4')
      var width = pdf.internal.pageSize.getWidth();;
      var height = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, 'PNG', 10, 0, width - 30, height);
      pdf.save('download.pdf');
      const base64String = canvas.toDataURL(pdf);
      localStorage.setItem("base64String", base64String.split(",")[1])
    })
  };

  const getPartnerId = async () => {
    try {
      const getStatus = await axios.get(
        `${partner_Api.GET_PID_DETAILS}?mobile=${partnerFlag == "true" ? partnerMobileNo : PartnerMobile}`,
        

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`
          },
        }

      );

      const res = decryptData(getStatus?.data);
      let decryptedResp = JSON.parse(res);
      if (decryptedResp?.status === 0) {
        setPartnerId(decryptedResp?.data?.info);
      } else {
        toast.error(decryptedResp?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    if(localStorage.getItem("partnerRole") === "Partner" ||
    localStorage.getItem("partnerRoleNew") === "Partner"){
    getPartnerId();
    }
    // setShowModal(true);
  }, []);


  const getPartnerInvoicePass = async () => {
    let payloadValue = {
      mobile: partnerFlag == "true" ? partnerMobileNo : PartnerMobile,
      password: inputVal?.toUpperCase(),
    };
    let encPayload = encryptData(JSON.stringify(payloadValue));
    try {
      const getValues = await axios.post(
        `${partner_Admin.Get_Partner_Invoice_Pass_Url}`,
        encPayload,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`
          },
        }
      );
      const invoiceData = decryptData(getValues?.data);
      let decryptedPass = JSON.parse(invoiceData);
      if (decryptedPass?.status === 0) {
        setInvoice(decryptedPass?.data?.info);
        setInvoiceDate(decryptedPass?.data?.info?.invoiceDate?.split("T")[0]);
        setShowModal(false);
        getPartnerInvoiceData(decryptedPass?.data?.info?.lastInvoiceId);
      }
      else if (decryptedPass?.status === 1) {
        setInvoice("");
        toast.error(decryptedPass?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");

    }
  };

  const getPartnerInvoiceData = async (invoice) => {
    try {
      const getValues = await axios.get(
        `${partner_Admin.GET_PARTNER_INVOICE}?invoiceId=${invoiceId ? invoiceId :invoice}`,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`
          },
        }
      );
      const invoiceData = decryptData(getValues?.data);
      let decryptedInvoice = JSON.parse(invoiceData);
      if (decryptedInvoice?.status === 0) {
        setInvoiceVal(decryptedInvoice?.data?.info);
        setInvoiceDate(decryptedInvoice?.data?.info?.invoiceDate?.split("T")[0]);
        const name = decryptedInvoice?.data?.info?.nameOnPan.split(" ")[0].slice(0, 3)
        setNameVal(name);

      }
      else if (decryptedInvoice?.status === 1) {
        setInvoice("");
        toast.error(decryptedInvoice?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  useEffect(()=>{
    if(localStorage.getItem("partnerRole") === "Admin" && sessionStorage.getItem("identifyFlag") === null){
      getPartnerInvoiceData();
    }
  }, [])

  const agreeAPI = async () => {
    let payloadValue = {
      partnerCode: invoiceVal?.partnerCode,
          panNo: invoiceVal?.panNo,
          invoiceId: (invoiceVal?.id).toString(),
          invoiceDate: invoiceDate.split("-").reverse().join("-"),
          file: localStorage.getItem("base64String"),
          InvoiceNo: invoiceVal?.invoiceNo,
          fileName: nameVal + invoiceVal?.partnerCode,
    };
    let encPayload = encryptData(JSON.stringify(payloadValue));
    try {
      const getRes = await axios.post(
        `${partner_Admin.GET_PARTNER_UPLOAD_INVOICE}`,
        encPayload,
        
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`
          },
        }
      );
      const agreeData = decryptData(getRes?.data);
      let decryptAgreeData = JSON.parse(agreeData);
      if (decryptAgreeData?.status === 0) {
        toast.success(decryptAgreeData?.data?.message)
        agreeButton()
      }
      else {
        toast.error(decryptAgreeData?.data?.message)
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  
  const disagreeAPI = async () => {
    let payloadValue = {
      Id: invoiceVal?.id,
      Status: 3
    };
    let encPayload = encryptData(JSON.stringify(payloadValue));
    try {
      const disAgreeRes = await axios.put(
        `${partner_Admin.GET_PARTNER_INVOICE}`,
        encPayload,
        
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`
          },
        }
      );
      const disagreeResp = decryptData(disAgreeRes?.data);
      let decryptDisagreeData = JSON.parse(disagreeResp);
      if (decryptDisagreeData?.status === 0) {
        toast.success(decryptDisagreeData?.data?.message)
        disagreeButton()
      }
      else {
        toast.error(decryptDisagreeData?.data?.message)

      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };
  function agreeButton() {
    document.getElementById('agreeButton').disabled = true;
  }
  function disagreeButton() {
    document.getElementById('disagreeButton').disabled = true;
  }

  const handleInputPass = (e) => {
    setInputVal(e?.target?.value?.toUpperCase());
    setPassError("");
  }

  const pdfHandle = () => {
    convertToPdf()
    setTimeout(() => {
      agreeAPI()
    }, 1000);
  }

  const onHide = () => {
    setShowModal(false);
  };

  const handleSubmitBtn = () => {
    getPartnerInvoicePass();
    if (inputVal === partnerId?.partnerCode + partnerId?.pan) {
      setShowModal(false);
      setPassError("");
    } else {
      setPassError("Enter Correct Password.");
    }
  }

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />

      <main id="main-content">
        <div className="card-box partner-source-card">
          <div className="partner-source-wrapper" ref={pdfRef}>
            <ul className="partner-invoice-wrapp" >
              <li>
                <p className="title-partner">
                  Invoice No: 
                  <span className="title-partner">{invoiceVal?.invoiceNo
                    || "-"}</span>
                </p>
              </li>
              <li>
                <p className="title-partner">
                  Invoice Date:
                  <span className="title-partner">{invoiceDate?.split("-")?.reverse()?.join("-") || "-"}</span>
                </p>
              </li>
            </ul>
            <ul className="partner-invoice-wrapp">
              <li>
                <p className="title-partner">
                  Details of Service Provider
                </p>
              </li>
              <li>
                <p className="title-partner">
                  Details of Service Recived
                </p>
              </li>
            </ul>
            <div className="partner-invoice-container">
              <ul>
                <li>
                  <p className="title-partner">GSTN:</p>
                  <span className="title-partner">NA</span>
                </li>
                <li>
                  <p className="title-partner">Name:</p>
                  <span className="title-partner">{invoiceVal?.nameOnPan || "-"}</span>
                </li>
                <li>
                  <p className="title-partner">Address: </p>
                  <span className="title-partner">
                    {invoiceVal?.address || "-"}
                  </span>
                </li>
                <li>
                  <p className="title-partner">State:</p>
                  <span className="title-partner">{invoiceVal?.state || "-"}</span>
                </li>
                <li>
                  <p className="title-partner">Serive period Of Invoice: </p>
                  <span className="title-partner">{invoiceVal?.servicePeriod || "-"}</span>
                </li>
                <li>
                  <p className="title-partner">Nature of Goods/Service:</p>
                  <span className="title-partner">Support Services</span>
                </li>
                <li>
                  <p className="title-partner">HSN/SAC:</p>
                  <span className="title-partner">998599</span>
                </li>
              </ul>
              <ul className="mobile-invoice-title">
                <li>
                  <p className="title-partner">
                    Invoice Date:{" "}
                    <span className="title-partner">{invoiceVal?.invoiceDate || "-"}</span>
                  </p>
                </li>
                <li>
                  <p className="title-partner">
                    Details of Service Recived
                  </p>
                </li>
              </ul>
              <ul>
                <li>
                  <p className="title-partner">GSTN:</p>
                  <span className="title-partner">27AAECB0643B1ZA</span>
                </li>
                <li>
                  <p className="title-partner">Name:</p>
                  <span className="title-partner">BAJAJ FINANCIAL SECURITIES LTD</span>
                </li>
                <li>
                  <p className="title-partner">Address:</p>
                  <span className="title-partner">
                    Bajaj Financial Securities Limited, <br />
                    Unit 2, Tower B, Opp. Inorbit Mall,  <br />
                    Mantri IT Park, Nagar Road, Viman  <br />
                    Nagar, Pune- 411014 <br />
                  </span>
                </li>
                <li>
                  <p className="title-partner">State:</p>
                  <span className="title-partner">MAHARASHTRA</span>
                </li>
                <li>
                  <p className="title-partner">State Code</p>
                  <p className="title-partner">27</p>
                </li>
              </ul>
            </div>
            <div className="partner-invoice-table">
              <div className="table-responsive scroll-table report-table-wrapper">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Count of Accounts</th>
                      <th scope="col" className="text-center">
                        Commission Per Account
                      </th>
                      <th scope="col" className="text-center">
                        Total Account Commission
                      </th>
                      <th scope="col" className="text-center">
                        Brokerage Gernaerated
                      </th>
                      <th scope="col" className="text-center">
                        Brokerage Commission
                      </th>
                      <th scope="col" className="text-center">
                        Total Brokerage Commission
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{invoiceVal?.noOfAccount || "-"}</td>
                      <td>{invoiceVal?.perAccountCommission || "-"}</td>
                      <td>{invoiceVal?.totalAccountCommission || "-"}</td>
                      <td>{invoiceVal?.brokerageGenerated || "-"}</td>
                      <td>{invoiceVal?.brokerageCommision || "-"}</td>
                      <td>{invoiceVal?.totalBrokerageCommission || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="total-amount">
              <ul>
                <li>
                  <p className="title-partner">Total Payable Amount:</p>
                  <span className="title-partner">{invoiceVal?.totalPayableAmount || "-"}</span>
                </li>
                <li>
                  <p className="title-partner">
                    Total Payable Amount,excluding TDS(in words):
                  </p>
                  <span className="title-partner"></span>
                </li>
                <li>
                  <p className="title-partner">TDS at 5% will be deducted:</p>
                  <span className="title-partner"></span>
                </li>
                <li>
                  <p className="title-partner">PAN No:</p>
                  <span className="title-partner">{invoiceVal?.panNo || "-"}</span>
                </li>
                <li>
                  <p className="title-partner">Bank Name:</p>
                  <span className="title-partner">NARELA</span>
                </li>
                <li>
                  <p className="title-partner">Bank Account No.:</p>
                  <span className="title-partner">{invoiceVal?.bankAcNumber || "-"}</span>
                </li>
                <li>
                  <p className="title-partner">Bank IFSC Code:</p>
                  <span className="title-partner">{invoiceVal?.ifscCode || "-"}</span>
                </li>
                <li>
                  <p className="title-partner">Total Payable Amount:</p>
                  <span className="title-partner">{invoiceVal?.totalPayableAmount || "-"}</span>
                </li>
                <li>
                  <p className="title-partner">
                    For(Vendor's Name)-Gaurav Kumar:
                  </p>
                  <span className="title-partner"></span>
                </li>
                <li>
                  <p className="title-partner">AUTHORIZED SIGNATORY:</p>
                  <span className="title-partner"></span>
                </li>
                <li>
                  <p className="title-partner">SAP Code:</p>
                  <span className="title-partner">{invoiceVal?.sapCode || "-"}</span>
                </li>
              </ul>
            </div>
          </div>

          {(localStorage.getItem("partnerRole") === "Partner" || 
          localStorage.getItem("partnerRoleNew") === "Partner") && invoiceVal !== "" ?
            <div className="btn-invoice-partner">
              <button type="submit" className="agree-btn" onClick={() => { pdfHandle() }} id="agreeButton">
                I Agree
              </button>
              <button type="submit" className="disagree-btn" id="disagreeButton" onClick={() => { disagreeAPI() }}>
                I Disagree
              </button>
            </div> : null}
        </div>
      </main>

      {localStorage.getItem("partnerRole") === "Partner" ||
      localStorage.getItem("partnerRoleNew") === "Partner" ?
        <Modal
          show={showModal}
          // onHide={() => setShowModal(false)
          // }
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="partner-invoice-model setting-model"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header className="mb-4 modal-header">
            <Modal.Title id="contained-modal-title-vcenter modal-title">
              <div className="figure-inlac">
                <h2 className="h2-css-all">Enter Invoice Password</h2>
                {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
              </div>
            </Modal.Title>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onHide}
            >
              <span className="icon-close"></span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div>
              <input
                type='text'
                placeholder='Enter Invoice Password upper-text'
                className='form-input'
                autoComplete="off"
                value={inputVal}
                maxLength={20}
                onChange={(e) => handleInputPass(e)}
              />

              <div className="invalid-error error-partner">{passError}</div>
              <button className='agree-btn'
                type="submit"
                onClick={() => handleSubmitBtn()}
              >Submit</button>
            </div>
          </Modal.Body>
        </Modal>
        : ""
      }



    </>
  );
}

export default PartnerInvoice;
